 
 import Form from '@/components/form.vue'
 import Form2 from '@/components/formtest.vue'
 import Login from '@/components/login.vue'
 import Frameio from '@/components/frameio.vue'
 import Videoview from '@/components/videoview.vue'
 import Audioview from '@/components/audioview.vue'
 import Imageview from '@/components/imageview.vue'
 
 
   export default[
 
  {
  	path:'/',component:Form,
   
    
  } ,
   {
    path:'/formtest',component:Form2,
    
  } ,
  {
    path:'/frameio',component:Frameio,
     name:'Frameio',
     meta: { requiresAuth: true }
  } ,
    {
    path:'/login',component:Login,
    
  } ,
  {
    path:'/videoview',component:Videoview,
     name:'Videoview'
  } ,
 
 {
    path:'/audioview',component:Audioview,
     name:'audioview'
  } ,
 
     
 {
    path:'/imageview',component:Imageview,
     name:'imageview'
  } ,
 
     

  ]





// WEBPACK FOOTER //
// ./src/router/index.js